const EulaZH = `
  <h1 class="static__title static__title--eula">《使用协议》</h1>
  <h2 class="static__subtitle">第一版，2017年9月15日</h2>
  <ul class="contents">
    <li class="contents__item"><a class="link static__link" href="#1">一、 定义及说明</a></li>
    <li class="contents__item"><a class="link static__link" href="#2">二、 总则</a></li>
    <li class="contents__item"><a class="link static__link" href="#3">三、 登录《服务》并获得信息</a></li>
  </ul>
  <ol class="info-about-static__content">
    <li class="info-about-static__content-first-items" id="1">
      <span class="list-item-title">定义及说明</span>
      <ol class="info-about-static__content-number-ol">
        <li class="info-about-static__content-number-ol-items">
          《服务》是指 Uchi.ru (Zhixuelong) https://zhixuelong.com/根据本《协议》条款提供的所有《服务》。
        </li>
        <li class="info-about-static__content-number-ol-items">
          Uchi.ru (Zhixuelong)&nbsp;&mdash; Limited Liability Company Https://zhixuelong.com/., Individual Taxpayer Number 7704821246, Primary National Registration Number 1127747152940, 公司地址: 121069, 俄罗斯联邦莫斯科市斯托洛维街4号楼4.1座
        </li>
        <li class="info-about-static__content-number-ol-items">
          用户是在《服务》中创建界面并同意该使用条款的自然人。《服务》用户是学生家长及其任课教师，以及个人资料需要被研究的学生，是通过学生家长完全无条件同意后进行的（需经过学生家长完全无条件同意）。
        </li>
        <li class="info-about-static__content-number-ol-items">
          界面是指用户账号，包括用户信息及全部登录信息；
        </li>
        <li class="info-about-static__content-number-ol-items">
          未成年学生登录受到特定限制，在家长和老师提供信息的情况下可以使用，但不是协议方；
        </li>
        <li class="info-about-static__content-number-ol-items">
          教师是自然人，可以实现登录，指导学生，有权依据法律和《协议》向https://zhixuelong.com/ 提供学生信息，包括但不限于学生个人信息；
        </li>
        <li class="info-about-static__content-number-ol-items">
          家长是自然人，可以登录进入网站协助学生登录，也可以收到关于学生使用情况的信息。该《协议》目的下的“家长”是指任意监护人、未成年人保护人或者代表学生并维护学生利益的亲生父母。另外的家长监护人和／或保护人同意。
        </li>
        <li class="info-about-static__content-number-ol-items">
          学校是指有在校生的国立或者私立教育机构。
        </li>
        <li class="info-about-static__content-number-ol-items">
           信息是指教师、学生家长为使用《服务》而输入的资料，包括教师、家长及学生个人信息。
        </li>

        <li class="info-about-static__content-number-ol-items">
          <ol class="info-about-static__content-number-ol">
            <br>
            <li class="info-about-static__content-number-ol-items under-item">
              《协议》是指用户与Https://zhixuelong.com/之间签订的本《协议》文本，包括Https://zhixuelong.com/一方向用户提供登录《服务》的全部重要条款，《服务》用户使用、知识产权及权限条款，《服务》使用中断或停止的条款，与使用《服务》有关的双方责任、其他关系。遵守本《协议》条款是用户使用《服务》的必要条件。
            </li>
            <li class="info-about-static__content-number-ol-items under-item">
              双方是指该《协议》双方。
            </li>
            <li class="info-about-static__content-number-ol-items under-item">
              Https://zhixuelong.com/.知识产权是知识活动的结果或者权利属于Https://zhixuelong.com/的个性化手段。
            </li>
            <li class="info-about-static__content-number-ol-items under-item">
               本《协议》的解释遵循以下原则：
               <ul class="unnumber-ul">
                 <li class="unnumber-ul__item">如果不要求根据上下文，本《协议》中带大写字母的所有术语均按其在本《协议》中所规定的含义。</li>
                 <li class="unnumber-ul__item">用于一种性的词语意味着任何一种性，用于单数的词语也意味着复数，反之亦然，引用整体意味着引用其中的任何一部分。</li>
                 <li class="unnumber-ul__item">引用“包括”或者“包括的”（或者任何类似术语）不应该解释为意味着某种限制和被“另外的”（或者任何类似术语）一词引入的总括词，</li>
                 <li class="unnumber-ul__item">它们不具有限定意义，因为它们的前提是明确行为、问题或者事件具体范畴的词语。</li>
               </ul>
            </li>
          </ol>
        </li>
      </ol>
    </li>
    <li class="info-about-static__content-first-items" id="2">
      <span class="list-item-title">总则</span>
      <ol class="info-about-static__content-number-ol">
        <li class="info-about-static__content-number-ol-items">
          本《协议》适用于所有《服务》用户，与其使用目的无关。《协议》行为从用户注册时刻起生效。按下“注册”键即意味着用户完全无条件同意本《协议》。本《协议》、《保密协议》、用户和Https://zhixuelong.com/的全部关系受俄罗斯联邦现行法律约束。
        </li>
        <li class="info-about-static__content-number-ol-items">
          如果用户不同意本《协议》，则应该立即终止使用《服务》，并删除在《服务》中输入的任何资料及信息。用户应该主动操作，利用一切可能的手段向Https://zhixuelong.com/报告终止使用《服务》的意愿。
        </li>
        <li class="info-about-static__content-number-ol-items">
          《协议》现行版本经常性发布在网站上：bricsmath.com /eula.
        </li>
        <li class="info-about-static__content-number-ol-items">
           Https://zhixuelong.com/保留在任何时刻不做预先或后续通知的情况下对本《协议》修改或补充的权力。用户自行关注《协议》变更并了解《协议》有效版本。
        </li>
        <li class="info-about-static__content-number-ol-items">
          本《协议》经过修改和（或）补充之后，用户继续使用意味着用户接受并同意所做出的修改和（或）补充。
        </li>
      </ol>
    </li>
    <li class="info-about-static__content-first-items" id="3">
      <span class="list-item-title">登录《服务》并获得信息</span>
      <ol class="info-about-static__content-number-ol">
        <li class="info-about-static__content-number-ol-items">
          需要在《服务》界面注册才能登录。
        </li>
        <li class="info-about-static__content-number-ol-items">
          在“教师”界面登录需要提供以下信息:
          <ul class="unnumber-ul">
            <li class="unnumber-ul__item">姓名</li>
            <li class="unnumber-ul__item">系方式(e-mail, 电话)</li>
            <li class="unnumber-ul__item">城市</li>
            <li class="unnumber-ul__item">学校及教育机构名称</li>
            <li class="unnumber-ul__item">班级</li>
            <li class="unnumber-ul__item">教师电话</li>
            <li class="unnumber-ul__item">学生信息 (姓名、性别、学校名称、班级)</li>
          </ul>
        </li>
        <li class="info-about-static__content-number-ol-items">
          教师向Https://zhixuelong.com/提供学生个人信息，教师保证自己或学校已经获得经学生家长或其法定代表人同意对学生个人资料进行处理并转让给第三方（包括跨境转让），本协议和《保密协议》中指定的目的，是该《协议》不可分割的一部分（以下是《保密协议》），以及学生使用本服务的情况。出于本协议和《隐私政下简称“隐私权政策”），以及学生对服务的使用。为本协议和隐私政策中策》中指定的目的，本协议的组成部分（以指定的目的，即本协议不可分割的一部分(以下称隐私政策)，以及学生使用本服务的情况。
        </li>
      </ol>
    </li>
  </ol>
`

export default EulaZH
